module.exports = __webpack_public_path__ + "img/floor_EG2.2df5bdd5.svg";